import TimePreview from "../../QuestionPreviews/TimePreview/TimePreview";

const TimeQuestion = ({ question }) => {
  const { isActive } = question;

  return <>{!isActive && <TimePreview question={question} />}</>;
};

export default TimeQuestion;
